/**
 * Notifications Tab - Coming Soon
 * Will include: Desktop Notifications, Notification Types, Quiet Hours
 */
export default function NotificationsTab({ profile, onUpdateProfile }) {
  return (
    <div className="p-6 max-w-4xl">
      <h3 className="text-xl font-semibold text-white mb-6">Notifications</h3>

      <div className="flex items-center justify-center h-64 bg-[#0a1628] rounded-lg">
        <div className="text-center">
          <div className="text-4xl mb-4">🔔</div>
          <h4 className="text-lg font-medium text-white mb-2">Notification Settings</h4>
          <p className="text-sm text-[#64748b] max-w-md">
            Desktop notifications, notification types, quiet hours, and custom notification settings coming soon!
          </p>
          <div className="mt-4 px-3 py-1.5 bg-[#00ad9f]/20 text-[#00ad9f] rounded text-xs font-semibold inline-block">
            Coming Soon
          </div>
        </div>
      </div>
    </div>
  )
}
